export default "__VITE_ASSET__17c65556__"